import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import IconButton from '@mui/material/IconButton'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import CustomPaper from '@/components/custom-paper'
import { HISTORY_RETURN_PARAM_KEY, ROUTE_SEGMENTS } from '@/constants/general'
import YearlyFeeCollectionSingle from '@/components/yearly-fee-collection/single'
import MunicipalityPermissionGate from '@/components/municipality-permission-gate'
import Breadcrumbs from '@/components/breadcrumbs'

function FeeCollectionYearView() {

    const { year } = useParams()

    const title = `Poplatek ${year}`

    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const historyReturn = params.get(HISTORY_RETURN_PARAM_KEY)

    const navigate = useNavigate()

    const link = `/${ROUTE_SEGMENTS.base}/${ROUTE_SEGMENTS.municipalityManagement}/${ROUTE_SEGMENTS.yearlyFeeCollection}`

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper noPadding>
                <Box px={2.5} pt={2.5}>
                    <Breadcrumbs />
                </Box>
                <Box px={2.5} pt={1} pb={2} display="flex" alignItems="center" gap={1}>
                    <IconButton
                        aria-label="close"
                        size="small"
                        color="terciary"
                        onClick={historyReturn === 'true' ?
                            () => navigate(-1) :
                            () => navigate(link)}
                    >
                        <ArrowBackRoundedIcon />
                    </IconButton>
                    <Typography variant="h3" component="h1">
                        {title}
                    </Typography>
                </Box>
                <MunicipalityPermissionGate>
                    <YearlyFeeCollectionSingle year={Number.parseInt(year)} />
                </MunicipalityPermissionGate>
            </CustomPaper>
        </>
    )
}

export default FeeCollectionYearView
